// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginAsAdmin_loginContainer__U9ydf","buttonLoginContainer":"LoginAsAdmin_buttonLoginContainer__+9Dyz"};